(function () {
  'use strict';

  /* ===== CONFIG: hier Preise, Förderung und CTA pflegen ===== */
  /* DIE WERTE KOMMEN AUS DEM THEME-EDITOR (12.10.2026), nicht mehr aus dieser Datei.
     window.BWP_HKR setzt die Section billigerwaermepumpe-heizkostenrechner.

     WARUM: Hier stehen Gaspreis, Heizoelpreis, Foerdersaetze und eine Frist (31.01.2027) -
     also genau die Angaben, die veralten, waehrend der Code bleibt. Wer sie pflegen muss,
     soll dafuer keinen Push brauchen.

     Die gelieferten Werte bleiben als Rueckfall stehen: Faellt das Skript aus der Section
     aus, rechnet der Rechner weiter - mit dem Stand von Oktober 2026 statt mit gar keinem. */
  var EIN = (typeof window !== 'undefined' && window.BWP_HKR) || {};
  var CONFIG = {
    stand: EIN.stand || 'Oktober 2026',
    ctaUrl: EIN.ctaUrl || 'https://billigerwaermepumpe.de/#beratung',
    foerderMaxKosten: EIN.foerderMaxKosten || 28000,
    foerderDefault: (EIN.foerderDefault !== undefined && EIN.foerderDefault !== null) ? EIN.foerderDefault : 46,
    foerder: (EIN.foerder && EIN.foerder.length) ? EIN.foerder : [
      { val: 0,  label: '0 %',  desc: 'Wir rechnen ohne Zuschuss.' },
      { val: 30, label: '30 %', desc: 'Grundförderung der KfW.' },
      { val: 46, label: '46 %', desc: 'Grundförderung plus 16 % Klimageschwindigkeitsbonus beim Tausch deiner Öl- oder Gasheizung (Antrag bis 31.01.2027).' },
      { val: 80, label: '80 %', desc: 'Zusätzlich Einkommensbonus bei zu versteuerndem Haushaltseinkommen bis 30.000 €. Die KfW deckelt bei 80 %.' }
    ],
    legal: EIN.legal || 'Unverbindliche Schätzung.'
  };

  /* ===== Rechenkern (rein, ohne DOM; testbar) ===== */
  function num(s) {
    if (s === null || s === undefined) return NaN;
    var t = String(s).replace(/\s/g, '');
    if (!t) return NaN;
    if (t.indexOf(',') >= 0) t = t.replace(/\./g, '').replace(',', '.');
    else if (/^\d{1,3}(\.\d{3})+$/.test(t)) t = t.replace(/\./g, '');
    var v = parseFloat(t);
    return isFinite(v) ? v : NaN;
  }
  function val(s, fb) { var v = num(s); return isNaN(v) ? fb : v; }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

  function calc(i) {
    var isGas = i.heiz === 'gas';
    var eta = clamp(val(i.eta, 85), 30, 110) / 100;
    var jaz = clamp(val(i.jaz, 3.5), 1.5, 7);
    var N = Math.round(clamp(val(i.years, 20), 5, 30));
    var gF = val(i.incF, 0) / 100, gS = val(i.incS, 0) / 100;
    var fuelKwh = isGas ? Math.max(0, val(i.gasKwh, 0)) : Math.max(0, val(i.oilL, 0)) * 10;
    var fuelCost = isGas ? fuelKwh * Math.max(0, val(i.gasCt, 0)) / 100 : Math.max(0, val(i.oilL, 0)) * Math.max(0, val(i.oilEur, 0)) / 100;
    var fixF = Math.max(0, val(i.fixF, 0)), fixWp = Math.max(0, val(i.fixWp, 200));
    var heat = fuelKwh * eta;
    var wpKwh = heat / jaz;
    var wpCost = wpKwh * Math.max(0, val(i.stromCt, 25)) / 100;
    var price = num(i.price), hasPrice = price > 0;
    var subsidy = hasPrice ? Math.min(price, i.foerderMax || 28000) * (i.foerder || 0) / 100 : 0;
    var invest = hasPrice ? price - subsidy : 0;
    var cumF = [0], cumW = [invest];
    for (var t = 1; t <= N; t++) {
      cumF.push(cumF[t - 1] + fuelCost * Math.pow(1 + gF, t - 1) + fixF);
      cumW.push(cumW[t - 1] + wpCost * Math.pow(1 + gS, t - 1) + fixWp);
    }
    var pb = null;
    if (hasPrice) {
      if (invest <= 0) pb = 0;
      for (var k = 1; k <= N && pb === null; k++) {
        var d0 = cumW[k - 1] - cumF[k - 1], d1 = cumW[k] - cumF[k];
        if (d1 <= 0) pb = (k - 1) + d0 / (d0 - d1);
      }
    }
    return {
      isGas: isGas, N: N, heat: heat, wpKwh: wpKwh, yearF: fuelCost + fixF, yearW: wpCost + fixWp,
      save1: (fuelCost + fixF) - (wpCost + fixWp), hasPrice: hasPrice, subsidy: subsidy, invest: invest,
      cumF: cumF, cumW: cumW, payback: pb, total: cumF[N] - cumW[N]
    };
  }

  /* Export für Tests (Node) */
  if (typeof module !== 'undefined' && module.exports) { module.exports = { calc: calc, num: num }; return; }
  if (typeof document === 'undefined') return;

  /* ===== UI ===== */
  var root = document.getElementById('bwp-rechner');
  var $ = function (id) { return document.getElementById(id); };
  var fmt0 = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });
  var fmt1 = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  var eur = function (v) { return fmt0.format(Math.round(v)) + ' €'; };
  var eurS = function (v) { return v < 0 ? '−' + eur(-v) : eur(v); };
  var state = { heiz: 'gas', foerder: CONFIG.foerderDefault, fixGas: '400', fixOil: '400' };

  $('bwp-legal').textContent = CONFIG.legal;
  $('bwp-cta').href = CONFIG.ctaUrl;

  var fWrap = $('bwp-foerder');
  CONFIG.foerder.forEach(function (o) {
    var b = document.createElement('button');
    b.type = 'button'; b.textContent = o.label; b.setAttribute('data-f', o.val);
    b.addEventListener('click', function () { state.foerder = o.val; update(); });
    fWrap.appendChild(b);
  });

  root.querySelectorAll('[data-heiz]').forEach(function (b) {
    b.addEventListener('click', function () {
      var fix = root.querySelector('[name=fixF]');
      state[state.heiz === 'gas' ? 'fixGas' : 'fixOil'] = fix.value;
      state.heiz = b.getAttribute('data-heiz');
      fix.value = state.heiz === 'gas' ? state.fixGas : state.fixOil;
      update();
    });
  });
  root.querySelector('form').addEventListener('input', update);
  root.querySelector('form').addEventListener('submit', function (e) { e.preventDefault(); });
  root.querySelector('details').addEventListener('toggle', postHeight);

  function inputs() {
    var o = { heiz: state.heiz, foerder: state.foerder, foerderMax: CONFIG.foerderMaxKosten };
    root.querySelectorAll('input[name]').forEach(function (el) { o[el.name] = el.value; });
    return o;
  }

  function update() {
    var r = calc(inputs());
    root.querySelectorAll('[data-heiz]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-heiz') === state.heiz)); });
    root.querySelectorAll('[data-show]').forEach(function (d) { d.hidden = d.getAttribute('data-show') !== state.heiz; });
    fWrap.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-f') === state.foerder)); });
    var fd = CONFIG.foerder.filter(function (o) { return o.val === state.foerder; })[0].desc;
    if (r.hasPrice && r.subsidy > 0) fd += ' Für dich: ' + eur(r.subsidy) + ' Zuschuss.';
    $('bwp-fdesc').textContent = fd;

    var pb = r.payback, label, cap = 'Ab hier rechnet sich deine Wärmepumpe', sum;
    if (!r.hasPrice) {
      label = '? Jahre';
      sum = 'Trag deinen Anschaffungspreis ein. Dann rechnen wir los. Deine laufende Ersparnis siehst du schon jetzt: ' + (r.save1 > 0 ? 'rund ' + eur(r.save1) + ' im ersten Jahr.' : 'mit diesen Werten keine.');
    } else if (pb !== null) {
      label = pb === 0 ? 'sofort' : '~' + fmt1.format(pb) + ' Jahre';
      sum = 'Im ersten Jahr sparst du ' + eur(r.save1) + ' Heizkosten. ' + (pb === 0 ? 'Nach Förderung zahlst du nichts drauf.' : 'Nach rund ' + fmt1.format(pb) + ' Jahren hast du deinen Eigenanteil wieder drin. Danach bleibt jeder Euro bei dir.');
    } else {
      label = '> ' + r.N + ' Jahre'; cap = 'Rechnet sich im Zeitraum nicht';
      sum = r.save1 > 0 ? 'Du sparst ' + eur(r.save1) + ' im Jahr, holst die Anschaffung in ' + r.N + ' Jahren aber nicht rein. Prüf Preis, Förderung und JAZ.'
        : 'Mit diesen Werten heizt die Wärmepumpe teurer als deine alte Heizung. Prüf Strompreis und JAZ.';
    }
    $('bwp-pb').textContent = label; $('bwp-pbc').textContent = cap; $('bwp-sum').textContent = sum;
    $('bwp-kf').textContent = eur(r.yearF); $('bwp-kw').textContent = eur(r.yearW);
    $('bwp-ki').textContent = r.hasPrice ? eur(r.invest) : '–';
    $('bwp-kis').textContent = r.hasPrice ? 'nach ' + eur(r.subsidy) + ' Förderung' : 'Preis fehlt noch';
    $('bwp-kt').textContent = r.hasPrice ? eurS(r.total) : '–';
    $('bwp-kts').textContent = 'nach ' + r.N + ' Jahren, inkl. Anschaffung';
    $('bwp-ct').textContent = 'Deine Kosten über ' + r.N + ' Jahre';
    $('bwp-fn').textContent = r.isGas ? 'Gasheizung' : 'Ölheizung';

    var N = r.N, maxV = Math.max(r.cumF[N], r.hasPrice ? Math.max(r.cumW[N], r.cumW[0]) : 0, 1);
    var nice = Math.pow(10, Math.floor(Math.log10(maxV))), top = Math.ceil(maxV / (nice / 2)) * (nice / 2);
    var path = function (a) { return a.map(function (v, i) { return (i ? 'L' : 'M') + (i / N * 600).toFixed(1) + ' ' + (240 - v / top * 240).toFixed(1); }).join(' '); };
    $('bwp-pf').setAttribute('d', path(r.cumF));
    $('bwp-pw').setAttribute('d', path(r.cumW));
    $('bwp-pw').setAttribute('visibility', r.hasPrice ? 'visible' : 'hidden');
    var showBe = r.hasPrice && pb !== null && pb > 0, bex = $('bwp-bex'), bel = $('bwp-bel');
    bex.setAttribute('visibility', showBe ? 'visible' : 'hidden');
    bel.hidden = !showBe;
    if (showBe) {
      var x = (pb / N * 600).toFixed(1);
      bex.setAttribute('x1', x); bex.setAttribute('x2', x);
      bel.style.left = clamp(pb / N * 100, 8, 92).toFixed(1) + '%';
      bel.textContent = '~' + fmt1.format(pb) + ' J.';
    }
    $('bwp-max').textContent = eur(top);
    $('bwp-mid').textContent = (N % 2 ? fmt1.format(N / 2) : N / 2) + ' J.';
    $('bwp-end').textContent = N + ' J.';
    $('bwp-svg').setAttribute('aria-label', 'Kumulierte Kosten über ' + N + ' Jahre: ' + (r.isGas ? 'Gasheizung ' : 'Ölheizung ') + eur(r.cumF[N]) + (r.hasPrice ? ', Wärmepumpe ' + eur(r.cumW[N]) : ''));
    postHeight();
  }

  /* DIE HOEHENMELDUNG AN EINE ELTERNSEITE IST ENTFALLEN (12.10.2026). Sie gehoerte zum
     Einbau als iFrame; hier steht der Rechner direkt in der Seite, es gibt also keine
     Elternseite, der etwas zu melden waere. postHeight() bleibt als leere Funktion, damit die
     beiden Aufrufe im Code nicht einzeln entfernt werden muessen - sie stehen an Stellen, an
     denen spaeter wieder etwas zu tun sein koennte. */
  function postHeight() {}

  update();
})();